import * as BABYLON from "babylonjs";
import * as React from "react";
import { GeoPoint } from "../../earth/core/geoPoint";
import { ResourceLoader } from "../../earth/core/resourceLoader";
import { FrameTime } from "../../earth/earthEngine";
import { EarthEngine } from "../../earth/earthEngine";
import { Main } from "../main";
import { UIContext } from "./uiContext";
import { UIContextAttractMode } from "./uiContextAttractMode";
import { UIContextNavigation } from "./uiContextNavigation";
import { UIGlobalState } from "./uiGlobalState";

export class UIContextLoadingScreen extends UIContext {
    readonly fadeDuration = 1.0;
    readonly noLoadDuration = 0.5;
    _timer = 0;

    enter(from: UIContext) {
        super.enter(from);
        EarthEngine.instance.camera.setPosition(new BABYLON.Vector3(3.0, 1.5, 2.0).normalize().scale(6.0));
        EarthEngine.instance.camera.focusOnPosition(new GeoPoint(40.0, 10.0), 1.8, 4.0);
    }

    update(time: FrameTime) {
        super.update(time);
        this._timer += time.deltaTime;
        if (ResourceLoader.loadInProgress) {
            this._timer = 0;
        }

        Main.instance.uiManager.refresh();
        if (this._timer > this.fadeDuration + this.noLoadDuration) {
            this.shouldSwitchToContext.emit( new UIContextAttractMode() );
        }
    }

     render(globalState: UIGlobalState): JSX.Element {
        return <div>
            {super.render(globalState)}
            <div className= { (this._timer > this.noLoadDuration) ? "fullscreen black ontop fadeout" : "fullscreen black ontop"}>
                <div style={{ position: "absolute" , width: "100px", height: "100px", top: "50%", left: "50%", margin: "-100px 0 0 -50px" }}>
                    <div className="loader">Please wait...</div>
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/uiContextLoadingScreen.tsx